<app-form-container [heading]="currentStep === 'withdrawal' ? 'Select Withdrawal Type' : 'Withdraw'">
  @if (currentStep === 'initial') {
    <form [formGroup]="initialForm" (ngSubmit)="onSubmit()">
      <div class="input-container">
        @if (isSettlementApp) {
          <div class="routing-options" role="group" aria-label="Routing mode">
            <button
              type="button"
              class="routing-option"
              [class.selected]="isAutomaticRouting"
              [attr.aria-pressed]="isAutomaticRouting"
              (click)="selectRoutingMode('automatic')"
            >
              <mat-icon>auto_awesome</mat-icon>
              <span>Automatic Routing</span>
            </button>

            <button
              type="button"
              class="routing-option"
              [class.selected]="!isAutomaticRouting"
              [attr.aria-pressed]="!isAutomaticRouting"
              (click)="selectRoutingMode('wallet')"
            >
              <mat-icon>account_balance_wallet</mat-icon>
              <span>Select Wallet</span>
            </button>
          </div>
        }

        <div class="form-group">
          <app-blockchain-dropdown
            label="Blockchain"
            placeholder="Select Blockchain"
            [options]="blockchainOptions()"
            formControlName="blockchain"
            [isInvalid]="getFieldError('blockchain', 'Blockchain') !== ''"
            [errorMessage]="getFieldError('blockchain', 'Blockchain')"
          >
          </app-blockchain-dropdown>
        </div>

        @if (isSettlementApp && isAutomaticRouting && riskGroupOptions.length > 0) {
          <div class="form-group">
            <app-dropdown
              label="Risk group"
              placeholder="Select Risk group"
              [options]="riskGroupOptions"
              formControlName="riskGroup"
              [isInvalid]="getFieldError('riskGroup', 'Risk group') !== ''"
              [errorMessage]="getFieldError('riskGroup', 'Risk group')"
            ></app-dropdown>
          </div>
        }

        @if (!isSettlementApp && isMultiRiskPaymentsEnabled && riskGroupOptions.length > 0) {
          <div class="form-group">
            <app-dropdown
              label="Risk group (Optional)"
              placeholder="Select Risk group"
              [options]="riskGroupOptions"
              formControlName="riskGroup"
              clearable
              [loading]="isLoadingAutomaticBalance"
              [isInvalid]="getFieldError('riskGroup', 'Risk group') !== ''"
              [errorMessage]="getFieldError('riskGroup', 'Risk group')"
            ></app-dropdown>
          </div>
        }

        @if (isSettlementApp && !isAutomaticRouting) {
          <div class="form-group">
            <app-text-input
              label="Sending Wallet"
              placeholder="Wallet Name"
              formControlName="sourceWalletDisplay"
              [readOnly]="true"
            ></app-text-input>
          </div>
        }

        <div class="form-group">
          <app-dropdown
            label="Select Currency"
            placeholder="Select Currency"
            [options]="currencyOptions"
            formControlName="currency"
            [isInvalid]="getFieldError('currency', 'Currency') !== ''"
            [errorMessage]="getFieldError('currency', 'Currency')"
          >
          </app-dropdown>
        </div>

        @if (!isSettlementApp) {
          <div class="form-group">
            <app-text-input
              label="Destination Wallet"
              placeholder="Select destination from options below"
              formControlName="destinationWalletDisplay"
              [readOnly]="true"
            ></app-text-input>
          </div>

          <div class="form-group with-available">
            <app-available-balance
              [balance]="availableBalance"
              [currencySymbol]="selectedCurrencySymbol"
              [precision]="currencyPrecision"
            />
            <app-text-input
              label="Amount"
              type="number"
              placeholder="Enter amount"
              formControlName="amount"
              [isInvalid]="getFieldError('amount', 'Amount') !== ''"
              [errorMessage]="getFieldError('amount', 'Amount')"
            ></app-text-input>
          </div>
        }
      </div>

      <div class="form-actions">
        <app-button
          buttonVariant="form-primary"
          buttonType="submit"
          [state]="initialNextButtonState"
        >
          Next
        </app-button>
      </div>
    </form>
  }
  @if (currentStep === 'withdrawal') {
    <form [formGroup]="withdrawalForm" (ngSubmit)="onSubmit()">
      <div class="input-container">
        @if (isSettlementApp) {
          <div class="form-group">
            <app-dropdown
              label="Withdrawal Type"
              placeholder="Select Withdrawal Type"
              [options]="withdrawalTypeOptions"
              formControlName="withdrawalType"
              [isInvalid]="getFieldError('withdrawalType', 'Withdrawal Type') !== ''"
              [errorMessage]="getFieldError('withdrawalType', 'Withdrawal Type')"
            >
            </app-dropdown>
          </div>
        }
        <div class="form-group">
          <app-text-input
            label="Destination Wallet"
            placeholder="Select destination from options below"
            formControlName="destinationWalletDisplay"
            [readOnly]="true"
          ></app-text-input>
        </div>

        <div class="form-group with-available">
          <app-available-balance
            [balance]="availableBalance"
            [currencySymbol]="selectedCurrencySymbol"
            [precision]="currencyPrecision"
          />
          <app-text-input
            label="Amount"
            type="number"
            placeholder="Enter amount"
            formControlName="amount"
            [isInvalid]="getFieldError('amount', 'Amount') !== ''"
            [errorMessage]="getFieldError('amount', 'Amount')"
          ></app-text-input>
        </div>
      </div>

      <div class="form-actions">
        <app-button buttonVariant="form-secondary" buttonType="button" (buttonClick)="onBackClick()">Back</app-button>
        <app-button
          buttonVariant="form-primary"
          buttonType="submit"
          [state]="withdrawalNextButtonState"
        >
          Next
        </app-button>
      </div>
    </form>
  }
</app-form-container>
